var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    "aria-label": "India flag",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 16,
    fill: "#ff9933"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 48,
    height: 16,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 48,
    height: 16,
    fill: "#138808"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 5.6,
    fill: "none",
    stroke: "#000080",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000080",
    strokeWidth: 0.55,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 25.4,
    y2: 18.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 26.7,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 27.8,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 28.6,
    y2: 21.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 29.1,
    y2: 22.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 29.3,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 29.1,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 28.6,
    y2: 26.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 27.8,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 26.7,
    y2: 28.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 25.4,
    y2: 29.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 22.6,
    y2: 29.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 21.3,
    y2: 28.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 20.2,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 19.4,
    y2: 26.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 18.9,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 18.7,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 18.9,
    y2: 22.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 19.4,
    y2: 21.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 20.2,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 21.3,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 22.6,
    y2: 18.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaflag);
export default __webpack_public_path__ + "static/media/indiaflag.58197edca1a94e5c7ab680261e980150.svg";
export { ForwardRef as ReactComponent };